export const COLOR_CATSKILL_WHITE = '#f5f8fa';
export const COLOR_AMARANTH = '#bb3b5c';

export const PRIMARY_COLOR = COLOR_AMARANTH;

export const BORDER_RADIUS = 10;

export const APPLICATION_PADDING = 15;
